import React from 'react';
import NavBar from './components/NavBar/NavBar';
import Hero from './components/Hero/Hero';
import ValueProp from './components/ValueProp/ValueProp';
import About from './components/About/About';
import FAQ from './components/FAQ/FAQ';
import CTA from './components/CTA/CTA';
import Footer from './components/Footer/Footer';
import './App.css';
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Hero />
      <ValueProp />
      <About />
      <FAQ />
      <CTA />
      <Footer />
      <Analytics />
    </div>
  );
}

export default App;
